export default "__VITE_ASSET__54e6eee8__"